var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"smileSelector"},[_c('div',{staticClass:"smileSelector__inner"},_vm._l((_setup.smiles),function(smile,index){return _c('span',{key:index,staticClass:"smileSelector__smile",on:{"click":function($event){return _setup.emitInput(smile)}}},[_vm._v(" "+_vm._s(smile)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }